import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const navHoveredAtom = atomFamily((index: string) => atom(false));
